import { ActionIcon, Button, Grid, Group, Modal, Paper, Stack, Text } from '@mantine/core';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Table from '../components/table';
import { useLanguage } from '../contexts/language.context';
import { carColors, getExtenseDatetime, groupBy } from '../utility/util';
import InputField, { InputFieldTypes } from '../components/input_field';
import { FaPlus } from 'react-icons/fa';
import { CREATE_MODEL, GET_ALL_MODELS, UPDATE_MODEL } from '../services/models';
import { CREATE_BRAND, GET_ALL_BRANDS, UPDATE_BRAND } from '../services/brands';
import { showNotification } from '@mantine/notifications';
import { CREATE_VEHICLE_CATEGORY, GET_ALL_VEHICLES_CATEGORIES, UPDATE_VEHICLE_CATEGORY } from '../services/vehicles_categories';

export default function Models() {
    const [categories, setCategories] = useState<any[]>([]);
    const [brands, setBrands] = useState<any[]>([]);
    const [models, setModels] = useState<any[]>([]);
    const [categoryModal, setCategoryModal] = useState<any>(null);
    const [brandModal, setBrandModal] = useState<any>(null);
    const [modelModal, setModelModal] = useState<any>(null);
    const [filters, setFilters] = useState<any>({
        brands: [],
        categories: [],
    })
    const [loadingSaveCategory, setLoadingSaveCategory] = useState<boolean>(false);
    const [loadingSaveBrand, setLoadingSaveBrand] = useState<boolean>(false);
    const [loadingSaveModel, setLoadingSaveModel] = useState<boolean>(false);
    const [loadingData, setLoadingData] = useState<boolean>(false);

    const { str } = useLanguage();

    const saveCategory = () => {
        const category = categoryModal;
        if (!category._id) {
            setLoadingSaveCategory(true);
            CREATE_VEHICLE_CATEGORY(category)
                .then(res => {
                    loadData();
                    setCategoryModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveCategory(false); })
        } else {
            setLoadingSaveCategory(true);
            let params = { ...category };
            delete params._id;
            UPDATE_VEHICLE_CATEGORY(category._id, params)
                .then(res => {
                    loadData();
                    setCategoryModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveCategory(false); })
        }
    }

    const saveBrand = () => {
        const brand = brandModal;
        if (!brand._id) {
            setLoadingSaveBrand(true);
            CREATE_BRAND(brand)
                .then(res => {
                    loadData();
                    setBrandModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveBrand(false); })
        } else {
            setLoadingSaveBrand(true);
            let params = { ...brand };
            delete params._id;
            UPDATE_BRAND(brand._id, params)
                .then(res => {
                    loadData();
                    setBrandModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveBrand(false); })
        }
    }

    const saveModel = () => {
        const model = modelModal;
        if (!model._id) {
            setLoadingSaveModel(true);
            CREATE_MODEL(model)
                .then(res => {
                    loadData();
                    setModelModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveModel(false); })
        } else {
            setLoadingSaveModel(true);
            let params = { ...model };
            delete params._id;
            UPDATE_MODEL(model._id, params)
                .then(res => {
                    loadData();
                    setModelModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveModel(false); })
        }
    }

    const loadData = async () => {
        try {
            setLoadingData(true);
            setCategories(await GET_ALL_VEHICLES_CATEGORIES());
            setModels(await GET_ALL_MODELS());
            setBrands(await GET_ALL_BRANDS());
        } catch (err: any) {
            showNotification({ message: err.message, color: "red" })
        } finally {
            setLoadingData(false);
        }
    }

    useEffect(() => {
        loadData();
    }, [])

    return <>
        <Grid>
            <Grid.Col span={{ md: 6 }}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    name="categories"
                    title="Categoria"
                    value={filters.categories}
                    onChange={({ categories }: any) => setFilters((f: any) => ({ ...f, categories }))}
                    multiple
                    options={categories.map(c => ({ label: c.title, value: c._id }))}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 6 }}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    name="brands"
                    title="Marca"
                    value={filters.brands}
                    onChange={({ brands }: any) => setFilters((f: any) => ({ ...f, brands }))}
                    multiple
                    options={brands.map(b => ({ label: b.title, value: b._id }))}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 12 }}>
                <Paper p="md">
                    <Stack>
                        <Group justify='flex-end'>
                            <Button onClick={() => setCategoryModal({})} leftSection={<FaPlus />}>Categoria</Button>
                            <Button onClick={() => setBrandModal({})} leftSection={<FaPlus />}>Marca</Button>
                            <Button onClick={() => setModelModal({})} leftSection={<FaPlus />}>Modelo</Button>
                        </Group>
                        <Table
                            loading={loadingData}
                            columns={[
                                { title: "Categoria", key: "category", render: (item) => item?.category?.title },
                                { title: "Marca", key: "brand", render: (item) => item?.brand?.title },
                                { title: "Modelo", key: "model", render: (item) => item.title },
                            ]}
                            actions={[
                                { title: "Editar", onClick: ({ item }) => setModelModal(item) }
                            ]}
                            data={models.filter(m => (
                                ((filters.categories ?? []).length === 0 || filters.categories.includes(m?.category?._id)) &&
                                ((filters.brands ?? []).length === 0 || filters.brands.includes(m?.brand?._id))
                            ))}
                        />
                    </Stack>
                </Paper>
            </Grid.Col>
        </Grid>

        <Modal
            opened={!!categoryModal}
            onClose={() => setCategoryModal(null)}
            size="xs"
        >
            <Stack>
                <InputField
                    name="title"
                    value={categoryModal?.title}
                    title="Categoria"
                    onChange={({ title }: any) => setCategoryModal((pv: any) => ({ ...pv, title }))}
                />
                <Group justify='flex-end'>
                    <Button
                        onClick={saveCategory}
                        loading={loadingSaveCategory}
                        disabled={!categoryModal?.title}
                    >Salvar</Button>
                </Group>
            </Stack>
        </Modal>
        <Modal
            opened={!!brandModal}
            onClose={() => setBrandModal(null)}
            size="xs"
        >
            <Stack>
                <InputField
                    name="title"
                    value={brandModal?.title}
                    title="Marca"
                    onChange={({ title }: any) => setBrandModal((pv: any) => ({ ...pv, title }))}
                />
                <Group justify='flex-end'>
                    <Button
                        onClick={saveBrand}
                        loading={loadingSaveBrand}
                        disabled={!brandModal?.title}
                    >Salvar</Button>
                </Group>
            </Stack>
        </Modal>
        <Modal
            opened={!!modelModal}
            onClose={() => setModelModal(null)}
            size="xl"
        >
            <Stack>
                <InputField
                    name="category"
                    value={modelModal?.category?._id ?? modelModal?.category}
                    title="Categoria"
                    onChange={({ category }: any) => setModelModal((pv: any) => ({ ...pv, category }))}
                    fieldType={InputFieldTypes.SELECT}
                    options={categories.map(b => ({ label: b.title, value: b._id }))}
                />
                <InputField
                    name="brand"
                    value={modelModal?.brand?._id ?? modelModal?.brand}
                    title="Marca"
                    onChange={({ brand }: any) => setModelModal((pv: any) => ({ ...pv, brand }))}
                    fieldType={InputFieldTypes.SELECT}
                    options={brands.map(b => ({ label: b.title, value: b._id }))}
                />
                <InputField
                    name="title"
                    value={modelModal?.title}
                    title="Nome"
                    onChange={({ title }: any) => setModelModal((pv: any) => ({ ...pv, title }))}
                />
                <Group justify='space-between'>
                    <Text>Cores</Text>
                    <ActionIcon onClick={() => { setModelModal((mm: any) => ({ ...mm, colors: [...(mm.colors ?? []), {}] })) }}><FaPlus /></ActionIcon>
                </Group>
                {
                    (modelModal?.colors ?? []).map((c: any, i: number) => <Paper style={{ backgroundColor: '#EFEFEF' }} p="md">
                        <InputField
                            name="color"
                            value={c.color}
                            clearable={false}
                            onChange={({ color }: any) => setModelModal((pv: any) => ({ ...pv, colors: modelModal.colors.map((c2: any, j: number) => i === j ? { ...c2, color } : c2) }))}
                            fieldType={InputFieldTypes.SELECT}
                            options={carColors.filter(cc => (cc.value === c?.color) || !(modelModal?.colors ?? []).some((cc2: any) => cc2.color === cc.value))}
                        />
                        <InputField
                            name="image"
                            value={c.image}
                            clearable={false}
                            onChange={({ image }: any) => setModelModal((pv: any) => ({ ...pv, colors: modelModal.colors.map((c2: any, j: number) => i === j ? { ...c2, image } : c2) }))}
                            fieldType={InputFieldTypes.IMAGE}
                        />
                    </Paper>)
                }

                <Group justify='flex-end'>
                    <Button
                        onClick={saveModel}
                        loading={loadingSaveModel}
                        disabled={!modelModal?.title || !modelModal?.brand || !modelModal?.category}
                    >Salvar</Button>
                </Group>
            </Stack>
        </Modal>
    </>
}
